import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { appInsightsInstrumentationKey } from './config'
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js'

if (!appInsightsInstrumentationKey) console.error('Missing App Insights Key')

function initAppInsights(history) {
  const reactPlugin = new ReactPlugin()
  const clickPlugin = new ClickAnalyticsPlugin()

  const clickPluginConfig = {
    autoCapture: true,
    dataTags: {
      useDefaultContentNameOrId: true,
      customDataPrefix: 'data-test',
    },
  }

  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: appInsightsInstrumentationKey,
      autoTrackPageVisitTime: true,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      correlationHeaderExcludedDomains: [
        '*media.azure.net',
        '*launchdarkly.com',
        '*blob.core.windows.net',
        '*google-analytics.com',
        'login-np-dev.cfctest.org',
        'login-np-qa.cfctest.org',
        'login-np-staging.cfctest.org',
        'login-np-constg.cfctest.org',
        'login.secondstep.org',
      ],
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      extensions: [reactPlugin, clickPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history },
        [clickPlugin.identifier]: clickPluginConfig,
      },
    },
  })

  appInsights.loadAppInsights()
  return appInsights
}

export default initAppInsights
